// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AA9iftBbiUsfs7upwUNR .zm9k6lXHqEtUEWsjcD5A{height:44px;margin-top:40px;font-size:14px;font-weight:500}.AA9iftBbiUsfs7upwUNR .CpkQq8mVcd8lZUrGgUV3{margin:24px 0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `AA9iftBbiUsfs7upwUNR`,
	"button": `zm9k6lXHqEtUEWsjcD5A`,
	"alertError": `CpkQq8mVcd8lZUrGgUV3`
};
export default ___CSS_LOADER_EXPORT___;
